<section class="betslip sb-panel" [class.betslip--expanded]="expanded()" [class.betslip--collapsed]="!expanded()">
  @if (expanded()) {
    @if (!showBackButton() || summary().selectionCount > 0) {
      <header class="betslip__header">
        <div class="betslip__title-row">
          <button
            type="button"
            class="betslip__header-button"
            [attr.aria-label]="(showBackButton() ? 'betslip.back' : 'betslip.collapse') | translate"
            (click)="toggleExpanded.emit()"
          >
            <span class="material-symbols-outlined betslip__header-icon" aria-hidden="true">chevron_left</span>
          </button>

          <span class="material-symbols-outlined betslip__title-icon" aria-hidden="true">confirmation_number</span>

          <div>
            <h2 class="betslip__title">{{ 'betslip.title' | translate }}</h2>
            @if (summary().selectionCount > 0) {
              <span class="betslip__type">{{ summary().ticketTypeKey | translate }}</span>
            }
          </div>
        </div>

        @if (summary().selectionCount > 0) {
          <button
            type="button"
            class="betslip__clear"
            [attr.aria-label]="'betslip.clear' | translate"
            (click)="clearBetSlip.emit()"
          >
            <span class="material-symbols-outlined betslip__clear-icon" aria-hidden="true">delete</span>
          </button>
        }
      </header>
    }

    <div class="betslip__body sb-scrollbar">
      @if (summary().selectionCount === 0) {
        <div class="betslip__empty">
          <span class="betslip__empty-icon" aria-hidden="true"></span>
          <h2 class="betslip__empty-title">{{ 'betslip.emptyTitle' | translate }}</h2>
          @if (showBackButton()) {
            <button #emptyBackButton type="button" class="betslip__empty-back" (click)="toggleExpanded.emit()">
              <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
              {{ 'betslip.back' | translate }}
            </button>
          }
        </div>
      } @else {
        <div class="betslip__groups">
          @for (group of groups(); track trackGroup($index, group)) {
            <article class="betslip__group" [class.betslip__group--invalid]="!group.active">
              <header class="betslip__group-header">
                <span>{{ group.matchName }}</span>
                @if (group.selections.length > 1) {
                  <span class="betslip__way-pill">{{ group.selections.length }} {{ 'betslip.waysShort' | translate }}</span>
                }
              </header>

              @for (selection of group.selections; track trackSelection($index, selection)) {
                <button
                  type="button"
                  class="betslip__selection"
                  [class.betslip__selection--armed]="isSelectionDeleteArmed(selection.key)"
                  [class.betslip__selection--invalid]="!selection.active || !group.active"
                  [attr.aria-label]="isSelectionDeleteArmed(selection.key) && mobileDeleteConfirm()
                    ? ('betslip.selectionDeleteAria' | translate)
                    : selection.selectionLabel"
                  (click)="onSelectionInteraction($event, group, selection)"
                >
                  <span class="betslip__selection-content">
                    <span class="betslip__selection-market">{{ selection.marketLabel }}</span>
                    <span class="betslip__selection-row">
                      <span class="betslip__selection-name">{{ selection.selectionLabel }}</span>
                      <span class="betslip__selection-odds">{{ selection.odds | number: '1.2-2' }}</span>
                    </span>
                    @if (!selection.active || !group.active) {
                      <span class="betslip__selection-state">{{ 'betslip.unavailable' | translate }}</span>
                    }
                  </span>
                  @if (mobileDeleteConfirm()) {
                    <span class="betslip__selection-delete-split" aria-hidden="true">
                      <span class="betslip__selection-delete-pane betslip__selection-delete-pane--confirm">
                        {{ 'betslip.delete' | translate }}
                      </span>
                      <span class="betslip__selection-delete-pane betslip__selection-delete-pane--abort">
                        {{ 'betslip.abort' | translate }}
                      </span>
                    </span>
                  } @else {
                    <span class="betslip__selection-delete-hint" aria-hidden="true">
                      <span class="material-symbols-outlined betslip__selection-delete-icon">close</span>
                    </span>
                  }
                </button>
              }
            </article>
          }
        </div>
      }
    </div>

    @if (summary().selectionCount > 0) {
      <footer class="betslip__footer">
        @if (activeNoticeKey(); as noticeKey) {
          <p
            class="betslip__notice"
            [class.betslip__notice--success]="submissionState().kind === 'accepted'"
            [class.betslip__notice--error]="submissionState().kind === 'declined' || submissionState().kind === 'error'"
            [class.betslip__notice--submitting]="submissionState().kind === 'submitting'"
            [attr.role]="submissionState().kind === 'declined' || submissionState().kind === 'error' ? 'alert' : 'status'"
            [attr.aria-busy]="submissionState().kind === 'submitting' ? 'true' : null"
          >
            <span class="betslip__notice-text">{{ noticeKey | translate: activeNoticeParams() }}</span>
          </p>
        }

        <div class="betslip__mode" role="group" [attr.aria-label]="'betslip.modeLabel' | translate">
          <button
            type="button"
            class="betslip__mode-button"
            [class.betslip__mode-button--active]="summary().effectiveMode === 'combi'"
            [attr.aria-pressed]="summary().effectiveMode === 'combi'"
            (click)="modeChange.emit('combi')"
          >
            {{ 'betslip.modes.combi' | translate }}
          </button>
          <button
            type="button"
            class="betslip__mode-button"
            [class.betslip__mode-button--active]="summary().effectiveMode === 'system'"
            [attr.aria-pressed]="summary().effectiveMode === 'system'"
            [disabled]="!summary().canUseSystem"
            (click)="modeChange.emit('system')"
          >
            {{ 'betslip.modes.system' | translate }}
          </button>
        </div>

        @if (summary().effectiveMode === 'system') {
          <div class="betslip__system">
            <button
              type="button"
              class="betslip__stepper"
              [disabled]="!summary().canDecreaseSystemX"
              [attr.aria-label]="'betslip.systemDecrease' | translate"
              (click)="systemStep.emit(-1)"
            >
              <span class="material-symbols-outlined betslip__stepper-icon" aria-hidden="true">remove</span>
            </button>
            <div class="betslip__system-copy">
              <span>{{ 'betslip.systemTicket' | translate: { x: summary().systemX, y: summary().systemY } }}</span>
              <small>{{ 'betslip.systemRows' | translate: { rows: summary().systemRows } }}</small>
            </div>
            <button
              type="button"
              class="betslip__stepper"
              [disabled]="!summary().canIncreaseSystemX"
              [attr.aria-label]="'betslip.systemIncrease' | translate"
              (click)="systemStep.emit(1)"
            >
              <span class="material-symbols-outlined betslip__stepper-icon" aria-hidden="true">add</span>
            </button>
          </div>
        }

        <label class="betslip__stake">
          <span class="betslip__stake-label">{{ 'betslip.stake' | translate }}</span>
          <span class="betslip__stake-currency">€</span>
          <input
            type="number"
            inputmode="decimal"
            [min]="summary().minStake"
            [max]="summary().maxAllowedStake"
            step="0.01"
            [value]="summary().stake"
            (input)="onStakeInput($event)"
          />
        </label>

        <div class="betslip__totals">
          <div class="betslip__total-row">
            <span>{{ 'betslip.ways' | translate }}</span>
            <strong>{{ summary().wayCount }}</strong>
          </div>
          @if (summary().tax > 0) {
            <div class="betslip__total-row">
              <span>{{ 'betslip.fee' | translate }}</span>
              <strong>€ {{ summary().tax | number: '1.2-2' }}</strong>
            </div>
          }
          <div class="betslip__total-row">
            <span>{{ 'betslip.netStake' | translate }}</span>
            <strong>€ {{ summary().netStake | number: '1.2-2' }}</strong>
          </div>
          <div class="betslip__total-row">
            <span>{{ 'betslip.totalOdds' | translate }}</span>
            <strong>{{ summary().totalOdds | number: '1.2-2' }}</strong>
          </div>
          @if (summary().bonusPercent > 0) {
            <div class="betslip__total-row">
              <span>{{ 'betslip.bonus' | translate }}</span>
              <strong>{{ summary().bonusPercent | number: '1.0-2' }}%</strong>
            </div>
          }
          <div
            class="betslip__total-row betslip__total-row--win"
            [appPulseOnChange]="pulseMaxWin() ? maxWinPulseKey() : 0"
          >
            <span>{{ 'betslip.maxWin' | translate }}</span>
            <strong>€ {{ summary().maxWin | number: '1.2-2' }}</strong>
          </div>
        </div>

        <button
          type="button"
          class="betslip__place-bet"
          [disabled]="!summary().primaryActionEnabled || submissionState().kind === 'submitting'"
          (click)="placeBet.emit()"
        >
          @if (submissionState().kind === 'submitting') {
            {{ 'betslip.submitting' | translate }}
          } @else {
            {{ summary().primaryActionKey | translate }}
          }
        </button>
      </footer>
    }
  } @else {
    <div class="betslip__collapsed">
      <button
        type="button"
        class="betslip__collapsed-expand"
        [attr.aria-label]="'betslip.expand' | translate"
        (click)="toggleExpanded.emit()"
      ></button>
      <div
        class="betslip__collapsed-header"
        aria-hidden="true"
      >
        <span class="material-symbols-outlined betslip__collapsed-header-icon" aria-hidden="true">chevron_right</span>
      </div>

      <div class="betslip__collapsed-body">
        <div class="betslip__collapsed-block">
          <span class="betslip__collapsed-label">{{ 'betslip.tips' | translate }}</span>
          <span class="betslip__collapsed-value betslip__collapsed-value--pill">{{ summary().selectionCount }}</span>
        </div>
        <div class="betslip__collapsed-divider"></div>
        <div class="betslip__collapsed-block">
          <span class="betslip__collapsed-label">{{ 'betslip.stake' | translate }}</span>
          <span class="betslip__collapsed-value">€{{ summary().stake | number: '1.0-2' }}</span>
        </div>
        <div class="betslip__collapsed-divider"></div>
        <div class="betslip__collapsed-block" [appPulseOnChange]="pulseMaxWin() ? maxWinPulseKey() : 0">
          <span class="betslip__collapsed-label">{{ 'betslip.maxWin' | translate }}</span>
          <span class="betslip__collapsed-value betslip__collapsed-value--win">
            €{{ summary().maxWin | number: '1.0-0' }}
          </span>
        </div>
      </div>

      <button
        type="button"
        class="betslip__collapsed-submit"
        [disabled]="!summary().primaryActionEnabled || submissionState().kind === 'submitting'"
        [attr.aria-label]="summary().primaryActionKey | translate"
        (click)="onCollapsedSubmitClick()"
      >
        <span class="material-symbols-outlined betslip__collapsed-submit-icon" aria-hidden="true">check</span>
      </button>
    </div>
  }
</section>
